import EmployeePortrait from '../../shared/EmployeePortrait';
import { formatFrenchPhone } from '../../utils/documentFormatters';
import CvCertificationItem from './CvCertificationItem';
import CvSection from './CvSection';
import CvSkillTags from './CvSkillTags';

const ContactIcon = ({ type }) => {
  const paths = {
    email: <><rect x="2.5" y="4" width="15" height="12" rx="1.5" /><path d="m3.5 5 6.5 5 6.5-5" /></>,
    phone: <path d="M5.2 2.8 8 6.1 6.4 8c1 2.1 2.5 3.6 4.6 4.6l1.9-1.6 3.3 2.8-.8 2.6c-.2.7-.9 1.1-1.6 1C7.6 16.4 3.6 12.4 2.6 6.2c-.1-.7.3-1.4 1-1.6z" />,
    location: <><path d="M10 18s5-5.2 5-10a5 5 0 0 0-10 0c0 4.8 5 10 5 10Z" /><circle cx="10" cy="8" r="1.8" /></>,
  };
  return <svg viewBox="0 0 20 20" aria-hidden="true">{paths[type]}</svg>;
};
const language = (item) => {
  if (typeof item === 'object') return { name: item.name || item.language || '', level: item.level || item.proficiency || '' };
  const [name, ...level] = String(item).split(/\s*(?::|—|-)\s*/);
  return { name, level: level.join(' — ') };
};

export default function CvSidebar({ data, composition, options }) {
  const employee = data.employee || {};
  return <aside className="cv-sidebar">
    <EmployeePortrait src={options.showPhoto === false ? null : employee.photoUrl} name={employee.fullName} />
    {options.showContactDetails !== false && (employee.email || employee.phone || employee.location) && <CvSection title="Coordonnées" sidebar><address>
      {employee.email && <span><ContactIcon type="email" /><b>{employee.email}</b></span>}
      {employee.phone && <span><ContactIcon type="phone" /><b>{formatFrenchPhone(employee.phone)}</b></span>}
      {employee.location && <span><ContactIcon type="location" /><b>{employee.location}</b></span>}
    </address></CvSection>}
    {data.presentation?.mobility && <CvSection title="Mobilité géographique" sidebar><p>{data.presentation.mobility}</p></CvSection>}
    {composition.coreSkills.length > 0 && <CvSection title="Expertises" sidebar><CvSkillTags skills={composition.coreSkills} /></CvSection>}
    {composition.softwareSkills.length > 0 && <CvSection title="Logiciels" sidebar><CvSkillTags skills={composition.softwareSkills} /></CvSection>}
    {data.presentation?.languages?.length > 0 && <CvSection title="Langues" sidebar><div className="cv-language-list">{data.presentation.languages.map((item, index) => { const value = language(item); return <p key={`${value.name}-${index}`}><strong>{value.name}</strong>{value.level && <span>{value.level}</span>}</p>; })}</div></CvSection>}
    {composition.certifications.length > 0 && <CvSection title="Habilitations" sidebar>{composition.certifications.slice(0, 3).map((item) => <CvCertificationItem key={item.id || item.name} certification={item} />)}</CvSection>}
  </aside>;
}
